// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_ta-0";